import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icons } from '@techsoftware/happay-widgets';
import CSV from '../../assets/images/csv.svg';
import XLS from '../../assets/images/xls.svg';
import PDF from '../../assets/images/pdf.svg';
export default class BillExport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  render() {
    return (
      <div>
        {!this.state.open ? (
          <span
            className="status green pointer"
            onClick={() => {
              this.setState({ open: true });
            }}
          >
            <Icons type="download" size="medium" />
          </span>
        ) : null}
        {this.state.open ? (
          <div className="speedDialIcon">
            <img
              src={PDF}
              alt="merchant"
              className="margin-10 pointer"
              onClick={() => {
                this.props.handleClick('pdf');
              }}
            />
            <img
              src={XLS}
              alt="merchant"
              className="margin-10 pointer"
              onClick={() => {
                this.props.handleClick('excel');
              }}
            />
            <img
              src={CSV}
              alt="merchant"
              className="margin-10 pointer"
              onClick={() => {
                this.props.handleClick('csv');
              }}
            />
            <Icons
              type="cross"
              size="midium"
              className="margin-10 pointer"
              onClick={() => {
                this.setState({ open: false });
              }}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

BillExport.propTypes = {
  handleClick: PropTypes.func,
};
